import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ServicioAuthService, UserLoginEntity } from '../../services/servicio-auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicioFiltersService } from '../../services/servicio-filters.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild('usuarioInput') usuarioInput: ElementRef;
  @ViewChild('claveInput') claveInput: ElementRef;

  // Variables
  private contUsername = 0;
  public loading = false;
  public userLogin: UserLoginEntity = {
    code : '',
    username : '',
    password : '',
    sedeId : 0,
    url : ''
  }
  public messageValidation: string;

  // Variables encargadas de mostrar las imagenes del login
  public seePassword = true;
  public seeLogo = false;

  // Variables encargados de activar los inputs
  public activeInputUsername = true;
  public activeInputPassword = false;
  public activeSede = false;

  // Variables para la validacion de los inputs:
  public validInputEmpty = false;
  public validUsername = false;
  
  // Variables para la validacion
  public invalidCode = false;
  public invalidUsername = false;
  public invalidPassword = false;
  public invalidSede = false;

  // Variables para errores
  public errorUsername = false;
  public errorPassword = false;
  public errorSede = false;

  public idSede: number;
  public listSedesFilter: any[] =[];

  constructor(private authorizationService: ServicioAuthService,
              private sedesFilterService: ServicioFiltersService,
              private router: Router) {  }

  ngOnInit() {  
    const obj = sessionStorage.getItem('auth_reporte');
    if(obj && obj.length > 0) {
      const { url, codigoBaseDatos } = JSON.parse(obj);
      const code: string = codigoBaseDatos
      if(code && code.trim().length > 0) {
        this.activeInputUsername = true;
        this.userLogin.code = code;
        this.userLogin.url = this.parseUrl(url);
      } else {
        this.invalidCode = true;
      }
    } else {
      this.activeInputUsername = false;
      this.invalidCode = true;
      this.seeLogo = true;
    }
  }

  parseUrl(url: any){
    url = url.replace('%3F','?');
    url = url.replace('%3D', '=');
    return url;
  }

  ngAfterViewInit() {
    this.usuarioInput.nativeElement.focus();
  }

  // Cargas
  private async getValidateUsername(code: string, username: string) {
    if (this.contUsername >= 3) {
      this.loading = false;
      this.validUsername = false;
      this.invalidUsername = true;
    } else {
      this.invalidUsername = false;
      this.errorUsername = false;
      const request = await this.authorizationService.getValidateUsernameRequest(code, username);
      request.subscribe((data: boolean) => {
        if (data) {
          this.loading = false;
          this.contUsername = 0;
          this.userLogin.username = username;
          this.activeInputUsername = false;
          this.activeInputPassword = true;
          setTimeout(() => {
            this.claveInput.nativeElement.focus();
          }, 0);
        } else {
          this.loading = false;
          this.contUsername++;
          this.invalidUsername = true;
        }
      }, (error: any) => {
        this.loading = false;
        this.errorUsername = true;
        console.error('getValidateUsername()', error);
      });
    }
  }

  private async getValidatePassword(code: string, username: string, pass: string) {
    this.errorPassword = false;
    const request = await this.authorizationService.getValidatePasswordRequest(code, username, pass);
    request.subscribe((data: boolean) => {
      if (data) {
        this.getFiltersSede(this.userLogin.code, this.userLogin.username);
      } else {
        this.invalidPassword = false;
        this.loading = false;
      }
    }, (error: any) => {
      this.loading = false;
      this.errorPassword = true;
      console.error('getValidatePassword()', error);
    })
  }

  private async getFiltersSede(code: string, username: string) {
    let listTemp = [];
    this.errorSede = false;
    const request = await this.sedesFilterService.getSedesFilterRequest(code, username);
    request.subscribe((data: any) => {
      if (data !== '') {
        listTemp = data;
        if(listTemp.length > 0) {
          if(listTemp.length === 1){
            this.userLogin.sedeId = Number(listTemp[0].id);
            this.getAuth();
          } else if (listTemp.length > 1){
            this.loading = false;
            this.idSede = -1;
            this.listSedesFilter = listTemp;
            this.activeInputPassword = false;
            this.activeSede = true;
          }
        } else {
          this.loading = false;
          this.invalidSede = true;
        }
      } else {
        this.loading = false;
        this.invalidSede = true;
      }
    }, (error: any) => {
      console.error('getFiltersSede()', error);
      this.errorSede = true;
      this.loading = false;
    });
  }

  private async getAuth() { 
    const request = await this.authorizationService.getAuthRequest(this.userLogin.code, this.userLogin.username,
    this.userLogin.password, this.userLogin.sedeId);
    request.subscribe((data: any) => {
      const token = data.headers.get('Authorization');
      this.authorizationService.login(token);
      this.loading = false;
      this.manageUrl(this.userLogin.url);
    }, (error: HttpErrorResponse) => {
      console.error('getAuth()', error);
      this.loading = false;
      if(error.status === 403) {
        this.messageValidation = error.error;
      } else {
        this.messageValidation = 'Error grave al intentar iniciar sesión, intente de nuevo.';
      }
    });
    
  }

  // Eventos
  public validateUsername(username: string) {
    if (username && username.trim() !== '') {
      this.loading = true;
      this.getValidateUsername(this.userLogin.code, username);
    } else {
      this.validInputEmpty = true;
    }
  }

  public validatePassword(pass: string) {
    if (pass != '' && !this.loading) {
      this.userLogin.password = pass;
      this.getValidatePassword(this.userLogin.code, this.userLogin.username, this.userLogin.password);
    } else {
      this.validInputEmpty = true;
    }
  }

  public validateSede() {
    if(this.idSede > -1) {
      this.userLogin.sedeId = this.idSede;
      this.loading = true;
      this.getAuth();
    } else {
      this.messageValidation = null;
      this.userLogin.sedeId = null;
      this.loading = false;
    }
  }

  public goBack(p: number) {
    switch(p) {
      case 2: {
        this.contUsername = 0;
        this.userLogin.username = '';
        this.activeInputUsername = true;
        this.activeInputPassword = false;
        this.messageValidation = null;
        setTimeout(() => {
          this.usuarioInput.nativeElement.focus();
        }, 0);
      }break;

      case 3: {
        this.messageValidation = null;
        this.userLogin.sedeId = null;
        this.idSede = -1;
        this.activeInputPassword = true;
        this.activeSede = false;
        setTimeout(() => {
          this.claveInput.nativeElement.focus();
        }, 0);
      }break;

      default: {} break;
    }
  }

  // Alerts
  public cleanInputUsername() {
    if (this.validInputEmpty || this.validUsername) {
      this.validInputEmpty = false;
      this.validUsername = false;
    }

    if ( this.invalidUsername ) {
      this.contUsername = 0;
      this.invalidUsername = false;
    }
  }

  public cleanInputPassword() {
    if (this.validInputEmpty || this.invalidPassword) {
      this.validInputEmpty = false;
      this.invalidPassword = false;
    }
  }

  // Auxiliares
  public isError() {
    return this.invalidCode;
  }

  // url
  public manageUrl(url: string) {
    let routes: string[] = [];
    let params: any = {};

    if (url.includes('?')){
      const split = url.split('/');
      const lastIndex = split.length -1;
      const lastItem = split[lastIndex];

      for(let i = 0 ; i < lastIndex; i++){
        routes.push(split[i]);
      }

      if (lastItem.includes('?')) {
        const split2 = lastItem.split('?');
        routes.push(split2[0]);

        const qparams = split2[1];
        params = this.getParams(qparams);
      }
      this.router.navigate(routes , { queryParams: params});
    } else {
      routes = url.split('/');
      this.router.navigate(routes);
    }
  }

  public getParams(val: string) {
    let obj = {};
    let status = 0;
    let key = '';
    let value = '';

    for(let i = 0; i < val.length; i++) {
      const letter = val[i];
      if (letter === '=') {
        status = 1;
      } else if (letter === '&'){
        obj[key] = value;
        key = '';
        value = '';
        status = 0;
      } else {
        if (status === 0) {
          key += letter;
        } else {
          value += letter;
        }
      }
    }

    if (status !== 0) {
      obj[key] = value;
    }

    return obj;
  }

}
